import classNames from "classnames";

import AscTag from "../../AscTag/AscTag";
import AscGenericCard from "../AscGenericCard/AscGenericCard";
import styles from "./AscBookCard.module.scss";

export interface AscBookCardProps {
  title?: string;
  coverImageUrl?: string;
  category?: string;
  className?: string;
  author?: string;
  loading?: boolean;
}

export default function AscBookCard({
  title,
  coverImageUrl,
  category,
  author,
  className,
  loading = false,
}: AscBookCardProps) {
  return (
    <AscGenericCard
      className={classNames(styles.ground, className)}
      title={title || ""}
      titleClassName={styles.title}
      imageClassName={styles.cardImage}
      coverImageUrl={coverImageUrl}
      contentClassName={styles.cardContent}
      data-testid={"asc-book-card"}
      loading={loading}
    >
      <div className={styles.author}>{author}</div>
      <AscTag label={category} type="pink" />
    </AscGenericCard>
  );
}
